import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const TransactionHistoryTabIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.66667 10.666V2.66602M4.66667 2.66602L2 5.33268M4.66667 2.66602L7.33333 5.33268M11.3333 5.33268V13.3327M11.3333 13.3327L14 10.666M11.3333 13.3327L8.66667 10.666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TransactionHistoryTabIcon;
